// extracted by mini-css-extract-plugin
export var equalColumn = "_h7-0";